import { Button, ButtonGroup, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomSelectBox from "../../components/CustomSelectBox/CustomSelectBox";
import {
  adduser,
  editUser,
  resetErrorMessages,
} from "../../redux/features/user.features";
import spinner from '../../assets/Spinner-1s-200px.svg'
import moment from "moment/moment";
import { DateTimePicker } from "@material-ui/lab";

const initialValues = {
  email: "",
  userId: "",
  registerDate: moment().toDate(),
  password: "",
  role: "basic",
  status: "Active",
};

const UserEntry = (props) => {
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.userReducer);
  const { validationError, successMessage, errorMessage, user, isLogin } =
    userState;
  const [values, setValues] = useState(initialValues);
  const [btnDisable, setbtnDisable] = useState(false);

  useEffect(() => {
    if (props.editMod) {
      console.log("edited user data", props.data);
      setValues(props.data);
    }
    dispatch(resetErrorMessages());
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setbtnDisable(false)
    setValues({
      ...values,
      [name]: value,
    });

    dispatch(resetErrorMessages());
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="row card__body">
            <div className="col-6">
              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                id="outlined-required"
                label="User id"
                defaultValue=""
                color="warning"
                margin="dense"
                name="userId"
                value={values.userId}
                onChange={handleChange}
              />

              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                id="outlined-required"
                label="email"
                placeholder="email..."
                name="email"
                defaultValue=""
                color="warning"
                onChange={handleChange}
                value={values.email}
              />

              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                id="outlined-required"
                label="user Name"
                placeholder="user Name..."
                name="userName"
                defaultValue=""
                color="warning"
                onChange={handleChange}
                value={values.userName}
              />
              {!props.editMod && (
                <TextField
                  style={{ color: "white", marginBottom: 16 }}
                  fullWidth
                  required
                  id="outlined-required"
                  label="password"
                  placeholder="password..."
                  name="password"
                  defaultValue=""
                  color="warning"
                  onChange={handleChange}
                  value={values.password}
                />
              )}

            
            </div>
            <div className="col-6">
              <CustomSelectBox
                items={["admin", "basic"]}
                onChange={handleChange}
                title="role"
                name="role"
                value={values.role}
              />

              <CustomSelectBox
                items={["Active", "DeActive"]}
                onChange={handleChange}
                title="Status"
                name="status"
                value={values.status}
              />
              <div style={{ marginBottom: 150 }}></div>

              <ButtonGroup
                fullWidth
                variant="contained"
                aria-label="outlined primary button group"
              >
                <Button onClick={props.cancel} color="warning">
                  Cancel
                </Button>
                {props.editMod ? (
                  <Button
                    onClick={(e) => dispatch(editUser(values))}
                    color="secondary"
                    disabled={btnDisable}
                  >
                    Edit User info {
                      btnDisable && ( <img style={{width:50}} src={spinner} alt="spinner"></img>)
                    }
                  </Button>
                ) : (

                  <Button
                    onClick={(e) => {
                      setbtnDisable(true)
                      dispatch(adduser(values))}}
                    color="success"
                    disabled={btnDisable}
                  >
                    Save {
                      btnDisable && !successMessage && ( <img style={{width:50}} src={spinner} alt="spinner"></img>)
                    }
                  </Button>
                )}
              </ButtonGroup>
            </div>
          </div>

          <div className="flex justify-center items-center text-red-600 font-extrabold">
            {errorMessage}
          </div>
          <div className="flex justify-center items-center text-red-600 font-extrabold">
            {validationError}
          </div>
          <div className="flex justify-center items-center text-white font-extrabold ">
            {successMessage && (
              <p className="bg-green-500 p-3 rounded ">{successMessage}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserEntry;
